import styled from 'styled-components';

export const LikeButtons = styled.div`
	position: relative;
	display: grid;
	grid-auto-flow: column;
	grid-gap: 8px;
`;

export const LikeButtonsWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	margin-left: auto;
	height: 32px;
`;
